// hooks/useInfiniteScroll.js
import { useState, useRef, useCallback, useEffect } from "react";

export function useInfiniteScroll(items, batchSize = 20) {
  const [visibleCount, setVisibleCount] = useState(batchSize);
  const sentinelRef = useRef(null);

  // Reset when the list itself changes (new search results)
  useEffect(() => {
    setVisibleCount(batchSize);
  }, [items, batchSize]);

  // Load next batch when sentinel enters viewport
  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisibleCount(prev => Math.min(prev + batchSize, items.length));
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [items.length, batchSize]);

  const visibleItems = items.slice(0, visibleCount);
  const hasMore = visibleCount < items.length;

  return { visibleItems, hasMore, sentinelRef };
}